import axiosInstance from '../config/axios';

// Get All Notifications
export const getAllNotifications = async () => {
    try {
        const response = await axiosInstance.get(`/notifications`);
        return response.data;
    } catch (error) {
        throw error.response?.data?.message || "Failed to fetch notifications";
    }
};

// Get Unread Notifications
export const getUnreadNotifications = async () => {
    try {
        const response = await axiosInstance.get(`/notifications/unread`);
        return response.data;
    } catch (error) {
        throw error.response?.data?.message || "Failed to fetch unread notifications";
    }
};

// Mark Read For Notification
export const markNotificationRead = async (Id) => {
    try {
        const response = await axiosInstance.post(`/notifications/read/${Id}`);
        return response.data;
    } catch (error) {
        throw error.response?.data?.message || "Failed to Send";
    }
}

// Mark Read For All Notification
export const markAllNotificationsRead = async () => {
    try {
        const response = await axiosInstance.post(`/notifications/read-all`);
        return response.data;
    } catch (error) {
        throw error.response?.data?.message || "Failed to Send";
    }
}
